unit UResources;

interface

{All strings are moved as resourcestring for easy localisation}
resourcestring
  sLineBreak = #13#10;
  sLeaving = 'Action needed before leaving';
  sLogFileName = 'LogWebCore.log';
  sInvalidDate = 'Error: Invalid date string';
  sPageLogin = ' Login';
  sPageMainMenu = 'MainMenu';
  sPageOrdersMenu = 'OrdersMenu';
  sPageOrders = 'Orders';
  sPageFirstLogin = 'FirstLogin';
  sPagePasswordReset = 'PasswordReset';
  sSessionStorageKey = 'fliegel-portal';
  sCookie = 'fliegel';
  sToastHeader = '<b style="font-size: 12pt">Information</b>';
  sToastTextde = '<font color="gray" style="font-size: 8pt">&#x25FC;</font><b style="font-size: 78t">Danke, ihr Daten wurden übermittelt</b>';
  sToastTexten = '<font color="gray" style="font-size: 8pt">&#x25FC;</font><b style="font-size: 78t">Thank you, your data has been updated</b>';
  sAPIUserOrderDataOnwards = 'auftrag_data/userdataonwards';

  //Email
  sSender = 'containerinfo@fliegel-portal.de';
  sSubject = 'Order %d updated';
  sName = 'Hello %s,';
  sBody = 'Updated numbers for order number %d. You have %d dirty containers, %d needed empty, %d empty back.'+ #13#10 + 'Thank you for lettings us know.';


//  sServerDateTimeFormat = 'dddd - dd.mm.yyyy hh:mm';

const
  sDashSeparator: char = '-';
  sDateFormat = 'dddd - dd.MM.yyyy';
  sDateTimeFormat = 'dddd - dd.MM.yyyy at hh:mm';
  sServerDate = 'yyyy-mm-dd';
  sServerDateTime = 'yyyy-mm-ddTHH:mm:ss.fff';
  sServerDateTimeFormat = 'dddd - dd.mm.yyyy hh:mm';
  sMilliSecondsinit = '.000';


implementation

end.


